import { defineRecipe } from "@chakra-ui/react/styled-system";
import { interactiveTransition } from "./_shared";

export default defineRecipe({
  base: {
    focusVisibleRing: "inside",
    focusRingWidth: "2px",
    ...interactiveTransition,
  },
  variants: {
    variant: {
      outline: {},
      subtle: {
        bg: "bg.muted",
      },
    },
  },
  defaultVariants: {
    variant: "outline",
  },
});
